import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import { Menu, Collapse } from 'grab-ui';
import { Mobile, ExceptMobile } from 'components/v2/responsive';
import {
  LOCALE_COUNTRY_MAP,
  LOCALE_LANGUAGE_MAP,
  SUPPORTED_LOCALES,
  COUNTRY_SUPPORTED_LOCALES,
} from 'constants/app-constants';
import { getUserCountryCode } from 'helper/user';
import { isDev } from 'common/utils/environment-util';

import css from './language-selector.less';
import DivButton from '../../div-button/div-button';

const { Item, SubMenu } = Menu;
const { Panel } = Collapse;

class LanguageSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderCurrentLanguage = () => {
    const locale = I18n.locale;
    const flagLocale = LOCALE_COUNTRY_MAP[locale];
    const flagSrc = require(`public/images/flags/${flagLocale}.svg`);
    return (
      <span>
        <img className={css.flagStyle} src={flagSrc} alt="flag" />
        {I18n.t(LOCALE_LANGUAGE_MAP[locale])}
      </span>
    );
  };

  renderLanguageDropdown = isMobileView => {
    const { handleLanguageSelect, userInfo } = this.props;
    const countryCode = getUserCountryCode(userInfo);
    const locales =
      // in PRD & STG, only support country specific local languages
      countryCode && !isDev()
        ? COUNTRY_SUPPORTED_LOCALES[countryCode.toLowerCase()] ||
          SUPPORTED_LOCALES
        : SUPPORTED_LOCALES;
    const currentLocale = I18n.locale;
    return locales.filter(locale => locale !== currentLocale).map(locale => {
      const flagCode = LOCALE_COUNTRY_MAP[locale];
      const flagSrc = require(`public/images/flags/${flagCode}.svg`);
      return isMobileView ? (
        <DivButton onClick={handleLanguageSelect(locale)} key={locale}>
          <img className={css.flagStyle} src={flagSrc} alt="flag" />
          {I18n.t(LOCALE_LANGUAGE_MAP[locale])}
        </DivButton>
      ) : (
        <Item key={locale} className={css.subItem}>
          <img className={css.flagStyle} src={flagSrc} alt="flag" />
          {I18n.t(LOCALE_LANGUAGE_MAP[locale])}
        </Item>
      );
    });
  };

  renderExpandIconMobile = () => (
    <img src={require('public/icons/collapsed.svg')} alt="" />
  );

  render() {
    return (
      <Fragment>
        <ExceptMobile>
          <SubMenu
            title={this.renderCurrentLanguage()}
            className={css.subMenuDesktop}
            {...this.props}
          >
            {this.renderLanguageDropdown(false)}
          </SubMenu>
        </ExceptMobile>
        <Mobile>
          <Collapse
            accordion
            expandIconPosition="right"
            expandIcon={this.renderExpandIconMobile}
            className={css.collapseMobile}
          >
            <Panel header={this.renderCurrentLanguage()}>
              {this.renderLanguageDropdown(true)}
            </Panel>
          </Collapse>
        </Mobile>
      </Fragment>
    );
  }
}

LanguageSelector.propTypes = {
  handleLanguageSelect: PropTypes.func,
  userInfo: PropTypes.shape({}).isRequired,
};

LanguageSelector.defaultProps = {
  handleLanguageSelect: () => {},
};

export default LanguageSelector;
